import { render, staticRenderFns } from "./dcFundList.vue?vue&type=template&id=19a4effe&scoped=true"
import script from "./dcFundList.vue?vue&type=script&lang=js"
export * from "./dcFundList.vue?vue&type=script&lang=js"
import style0 from "./dcFundList.vue?vue&type=style&index=0&id=19a4effe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a4effe",
  null
  
)

export default component.exports